import AdvertisingMasterPage from './AdvertisingMasterPage';

export default AdvertisingMasterPage;
